import axios from 'axios';
import router from '../router';
import { showNotify } from 'vant';
// create an axios instance
const service = axios.create({
  // baseURL: 'http://admin.xueli1.cn', // url = base url + request url
  baseURL: 'https://admin.xueli2.cc', // url = base url + request url
  timeout: 50000, // request timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    config.headers['cookie'] = window.sessionStorage.getItem('token');
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;
    if (res.code === 1) {
      return res;
    } else {
      // console.log(res);

      if (res.code == 401) {
        router.push('/index');
        console.log(router);

        window.sessionStorage.removeItem('token');
      }
      showNotify(res.msg);
      // return false;
      return res;
    }
    // const url = response.config.url;
    // if (res.code === 402) {
    //   // 未登录或未授权
    //   throw new ApiAuthError(url)
    // } else if (res.code === 401) {
    //   throw new ApiRoleError(url)
    // } else if (res.code === 40201) {
    //   throw new ApiRepeatError()
    // } else {
    //   throw new ApiBusinessError(res.message || 'Error', res.code, url, res.data)
    // }
  },
  (error) => {
    console.log(error);
    // throw new ApiServerError(error.response?.status, error.config?.url)
  }
);

export const { post, get, put } = service;

export default service;

// export const delay = (second) => (data) =>
//   new Promise((resolve) => {
//     setTimeout(() => {
//       // resolve(data);
//     }, second * 1000);
//   });
